import { plural } from './text-formatters';

const ONES = ['', 'один', 'два', 'три', 'четыре', 'пять', 'шесть', 'семь', 'восемь', 'девять'];
const ONES_FEMININE = ['', 'одна', 'две', ...ONES.slice(3)];
const TEENS = [
  'десять',
  'одиннадцать',
  'двенадцать',
  'тринадцать',
  'четырнадцать',
  'пятнадцать',
  'шестнадцать',
  'семнадцать',
  'восемнадцать',
  'девятнадцать',
];
const TENS = [
  '',
  '',
  'двадцать',
  'тридцать',
  'сорок',
  'пятьдесят',
  'шестьдесят',
  'семьдесят',
  'восемьдесят',
  'девяносто',
];
const HUNDREDS = [
  '',
  'сто',
  'двести',
  'триста',
  'четыреста',
  'пятьсот',
  'шестьсот',
  'семьсот',
  'восемьсот',
  'девятьсот',
];
/** Разряды от младшего: единицы, тысячи (женский род), миллионы, миллиарды. */
const SCALES: { forms: [string, string, string] | null; feminine: boolean }[] = [
  { forms: null, feminine: false },
  { forms: ['тысяча', 'тысячи', 'тысяч'], feminine: true },
  { forms: ['миллион', 'миллиона', 'миллионов'], feminine: false },
  { forms: ['миллиард', 'миллиарда', 'миллиардов'], feminine: false },
];

const triadWords = (value: number, feminine: boolean): string[] => {
  const tens = value % 100;
  const ones = feminine ? ONES_FEMININE : ONES;

  return [
    HUNDREDS[Math.floor(value / 100)] ?? '',
    tens >= 10 && tens < 20 ? (TEENS[tens - 10] ?? '') : (TENS[Math.floor(tens / 10)] ?? ''),
    tens >= 10 && tens < 20 ? '' : (ones[tens % 10] ?? ''),
  ];
};

/** Сумма прописью для счёта: «Девять тысяч четыреста рублей 00 копеек». */
export const rublesInWords = (kopecks: number): string => {
  const rubles = Math.floor(kopecks / 100);
  const cents = kopecks % 100;
  const words: string[] = [];

  for (const [scale, { forms, feminine }] of [...SCALES.entries()].reverse()) {
    const triad = Math.floor(rubles / 1000 ** scale) % 1000;
    if (triad === 0) continue;
    words.push(...triadWords(triad, feminine), forms ? plural(triad, forms) : '');
  }

  const text = [
    ...(rubles === 0 ? ['ноль'] : words),
    plural(rubles, ['рубль', 'рубля', 'рублей']),
    String(cents).padStart(2, '0'),
    plural(cents, ['копейка', 'копейки', 'копеек']),
  ]
    .filter(Boolean)
    .join(' ');

  return text.charAt(0).toUpperCase() + text.slice(1);
};
